// Source of truth, kept in sync manually:
// https://github.com/wix-private/promote-server/blob/master/email-address-validation-app/resources/blacklisted-domains.txt
const TYPOS_BY_CORRECT_DOMAIN = {
    'aol.com': [
        'aaol.com',
        'aol.con',
        'aool.com',
        'aol.cpm'
    ],
    'gmail.com': [
        'ail.com',
        'gail.com',
        'gamail.com',
        'gamil.com',
        'gemail.com',
        'gmai.com',
        'gmail.cm',
        'gmail.cmo',
        'gmail.co',
        'gmail.com.com',
        'gmail.con',
        'gmailc.om',
        'gmaill.com',
        'gmaim.com',
        'gmal.com',
        'gmali.com',
        'gmaol.com',
        'gmeil.com',
        'gmial.com',
        'gmqil.com',
        'gmsil.com',
        'gnail.com',
        'hmail.com',
        'fmail.com',
        'gmail.cpm',
        'gmail.vom',
        'gmail.comm'
    ],
    'hotmail.com': [
        'hitmail.com',
        'homail.com',
        'hotmai.com',
        'hotmail.con',
        'hotmaill.com',
        'hotmal.com',
        'hotmali.com',
        'hotmaol.com',
        'hotmial.com',
        'htmail.com',
        'hormail.com',
        'hotmail.cpm',
        'hotmil.com'
    ],
    'icloud.com': [
        'iclod.com',
        'iclou.com',
        'icloud.con',
        'icloude.com',
        'iclould.com',
        'icolud.com',
        'icoud.com',
        'ivloud.com',
        'icloud.cpm'
    ],
    'outlook.com': [
        'otlook.com',
        'outllook.com',
        'outlok.com',
        'outlook.con',
        'outlookk.com',
        'outloook.com',
        'outook.com',
        'outlook.cpm'
    ],
    'yahoo.com': [
        'yagoo.com',
        'yaho.com',
        'yahoo.con',
        'yahooo.com',
        'yahou.com',
        'yaoo.com',
        'yhaoo.com',
        'yhoo.com',
        'yajoo.com',
        'yahoo.cpm'
    ],
    'live.com': [
        'live.con',
        'liv.com',
        'lve.com',
        'live.cpm'
    ],
    'msn.com': [
        'msn.con',
        'msn.com.com',
        'mmsn.com',
        'msn.cpm'
    ],
    'me.com': [
        'me.con',
        'me.cpm'
    ],
    'mac.com': [
        'mac.con',
        'mac.cpm'
    ],
    'comcast.net': [
        'comcast.ne',
        'comcast.nt',
        'comcast.netc',
        'comcast.nrt',
        'comcast.net.net'
    ]
};
export const MISTYPED_EMAIL_DOMAINS = new Map(Object.entries(TYPOS_BY_CORRECT_DOMAIN).flatMap(([correctDomain, typos])=>typos.map((typo)=>[
            typo,
            correctDomain
        ])));

//# sourceMappingURL=mistyped-email-domains.js.map